import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import CalendarIcon from '@atlaskit/icon/glyph/calendar';
// eslint-disable-next-line import/order
import { Box, xcss } from '@atlaskit/primitives';

import { gridSize, fontSize } from '@atlassian/jira-common-styles/src/main.tsx';

type Props = {
	calendarName: string;
};

export const CalendarViewField = ({ calendarName }: Props) => (
	<ValueContainer>
		<ReadViewContainerWithFF>{calendarName}</ReadViewContainerWithFF>
	</ValueContainer>
);

const ValueContainer = ({ children }: { children: ReactNode }) => (
	<CalendarContainer>
		<Box
			xcss={calendarIconContainerStyles}
			testId="servicedesk-sla-settings.ui.metrics.metric.metric-view.goals.goal.calendar.calendar-icon-container"
		>
			<CalendarIcon label="" />
		</Box>
		{children}
	</CalendarContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CalendarContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
});

const calendarIconContainerStyles = xcss({
	paddingRight: 'space.075',
	paddingTop: 'space.025',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReadViewContainerWithFF = styled.td({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: (gridSize * 2.5) / fontSize,
	maxWidth: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${(gridSize * 2.5) / fontSize}em`,
	wordBreak: 'break-word',
});
